<template>
  <div>
    <div v-if="data.QuestionType === 'Close'" class="text-center">
      <p>{{ data.Description }}</p>
      <!-- stars -->
      <v-rating
        v-if="
          !postSurveyView.closeQuestionType ||
          (postSurveyView.closeQuestionType &&
            postSurveyView.closeQuestionType == 'stars')
        "
        v-model="surveyAns"
        :length="data.MaxAnswer"
        background-color="orange lighten-3"
        color="orange"
        @mouseup="$emit('onStartRate')"
      ></v-rating>

      <!-- numbers -->

      <v-rating
        class="number-type-rate"
        v-if="
          postSurveyView.closeQuestionType &&
          postSurveyView.closeQuestionType == 'numbers'
        "
        v-model="surveyAns"
        :length="data.MaxAnswer"        
        @mouseup="$emit('onStartRate')"
      >
        <template v-slot:item="props">
          <button
            v-bind="props"
            :class="{
              'circle-btn': true,
              'filled': props.isFilled,
              'not-filled': !props.isFilled,
            }"
          >
            {{ props.index + 1 }}
          </button>
        </template>
      </v-rating>

      <!-- slider -->
      <v-slider
        v-if="
          postSurveyView.closeQuestionType &&
          postSurveyView.closeQuestionType == 'slider'
        "
        v-model="surveyAns"
        @mouseup="$emit('onStartRate')"
        :max="data.MaxAnswer"
        thumb-label
        :ticks="getArray()"
      ></v-slider>
    </div>
    <div v-if="data.QuestionType === 'Open'" class="text-center">
      {{ data.Description }}
      <v-text-field
        autocomplete="off"
        variant="underlined"
        v-model="surveyAns"
        @keyup="$emit('onStartRate')"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyQna",
  props: ["data"],
  emits: ["onStartRate"],
  data() {
    return { surveyAns: "" };
  },
  computed: {
    ...mapGetters(["appData", "widgetData", "postSurveyView"]),
  },
  methods: {
    getArray() {
      var max = this.data.MaxAnswer;
      var arr = [];
      for (var i = 1; i <= max; i++) {
        arr.push(i.toString());
      }

      return arr;
    },
  },
  watch: {
    surveyAns(newAns, oldAns) {
      this.data.surveyAns = newAns;
    },
  },
};
</script>

<style scoped></style>
